export default (function (_ref) {
  var service = _ref.service,
    request = _ref.request;
  return {
    getCurrencyUnitList: function getCurrencyUnitList() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/admin/currency_unit/get",
        method: "get",
        params: data
      });
    },
    addCurrencyUnit: function addCurrencyUnit() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/admin/currency_unit/add",
        method: "post",
        data: data
      });
    },
    updateCurrencyUnit: function updateCurrencyUnit() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/admin/currency_unit/update",
        method: "post",
        data: data
      });
    }
  };
});